import Layer from './Layer.js';

function Layers(config, legend) {
  this.legend = legend
  this.list = []
  this.defaultImgTyp = config.defaultImgTyp

  // *** initilization code ***

  // copy all dLegend defined layers into rwg.layers.list
  let legendLayers = legend.getToggleableLayers()
  for (let i in legendLayers) {
    this.list.push(new Layer(
      legendLayers[i].id,
      {state: legendLayers[i].checked},
      this.defaultImgTyp
    ));
  }

  /** Assign the info handler function for info layers.
      This may not be necessary becasue a layer should
      have an "info" property even if it's just
        info: ()=>{}
  */
  for (let i in config.infoLayers) {
    let layer = this.getLayerByName(i);
    if (layer !== undefined) {
      layer.info = config.infoLayers[i];
    }
  }

  // overwrite the default 'olLayer' for layers that have their own client-side OL layer
  // this assumes that there's only one server-side layer per olLayer
  for (let i in config.olLayers) {
    let layer = this.getLayerByName(config.olLayers[i].name);
    if (layer !== undefined) {
      layer.olLyr = config.olLayers[i].name;
      // if (layerObject.state) {
      //   olLayerToTurnOn = layer.name;
      // }
    }
  }

  // set layer options from etc/conf.js file
  // can be used instead of infoLayers, jpegLayers, olLayers
  for (let opt in config.layerOptions) {
    let lyr = this.getLayerByName(opt);
    if (lyr) {
      lyr.setOptions(config.layerOptions[opt]);
    }
  }

  this.list.reverse()  // make WMS friendly
}

Layers.prototype.getLayerByName = function(layerName) {
  for (var i = 0, l = this.list.length; i < l; i++) {
    if (this.list[i].name === layerName) {
      return this.list[i];
    }
  }
};

/** getActiveDrawLayers()
 * Returns array, usage:
 *    getActiveDrawLayers().join(' ')  // for mapserv
 *    getActiveDrawLayers().join(',')  // for WMS
 *
 *    With the optional olLayer parameter only active server-side
 *    layers for the specified olLayer will be returned.
 *    When we're populating the dLegend layer control we want all layers
 *    But when we're manipulating lyrMapservFore we only want its layers.
 */
Layers.prototype.getActiveDrawLayers = function(olLayer) {
  var activelayers = [];
  for (var i = 0, l = this.list.length; i < l; i++) {
    if (this.list[i].state)  { // if it's set: true
      if (typeof olLayer === 'undefined' || this.list[i].olLyr === olLayer) {
        activelayers[activelayers.length] = this.list[i].name;
        // activelayers.push(this.list[i].name);
      }
    }
  }
  return (activelayers);
};

/*
  rwg.infoLayers may or may not be a function
  if info is rendered by a mapserv template then it's just true/false
*/
Layers.prototype.getActiveInfoLayers = function() {
  let qlayers = [];
  this.list.forEach(function(layer) {
    if (layer.state && layer.info) {
      qlayers.push(layer.name);
    }
  });
  return qlayers.join('+'); // formatted of a URL
};

// client-side vector layers with info
// returns array
Layers.prototype.getActiveLocalInfoLayers = function() {
  let localInfoLayers = [];
  this.list.forEach(function(layer) {
    if (layer.state && layer.infov) {  // info function name must be "infov"
      localInfoLayers.push(layer.name);
    }
  });
  return localInfoLayers.length ? localInfoLayers : null;
};

/** getImageType()
 *  WRONG -> @param {OpenLayers.Layer} olLayer
 *  @param {string} olLayer name
 *  @return {string}
 *  If any of the server-side layers in a client-side group are jpeg
 *  then return jpeg, otherwise return the default image type
 */
Layers.prototype.getImageType = function(olLayerName) {  // some rwg.mapRequestType would be nice (i.e. WMS versus mapserv)
  // could query lyrBase.params.SERVICE to determine WMS versus mapserver
  // but would need "lyrBase" which would be the olLayerName name

  let imagetype = this.defaultImgTyp;
  for (let i = 0, l = this.list.length; i < l; i++) {
    // Not sure test typeof olLayerName === 'undefined' is needed
    if ((typeof olLayerName === 'undefined' || this.list[i].olLyr === olLayerName) && this.list[i].state) {
      if (this.list[i].imgType !== this.defaultImgTyp) {
        imagetype = this.list[i].imgType
      }
    }
  }
  return (imagetype);
};

/**
 * return an array of layers where key === value
 * optionally filtered by olLayerName
 */
Layers.prototype.getLayersBy = function(key, val, olLayerName) {  // olLayerName is optional
  var layers = [];
  this.list.forEach(function(lyr) {
    for (var property in lyr) {
      if (lyr.hasOwnProperty(property) &&
          property === key && lyr[property] === val &&
          (typeof olLayerName === 'undefined' || lyr.olLyr === olLayerName)
      ) {
        layers.push(lyr);
      }
    }
  });
  return layers;
};

/** Activates layers specified in the query string during initilization
 * also called by county config.js to turn on layers
 * also called in assessor-3.2.js
 * not the best name for what it does
 * @param {string} layers - string of space delimited layer names
*/
Layers.prototype.addLayers = function (layers) {
  var i, len, addlayers = layers.split(' ');
  for (i = 0, len = addlayers.length; i < len; i++) {
    // try/catch allows us to specify layers that are not in the layer control, e.g. ownershipq, nbuffer, etc.
    // another approach would be: if (layers.getLayersBy('name', lyr).length) {
    try {
      this.legend.check(addlayers[i]);
      this.legend.expand(addlayers[i]);
    } catch(e) {
      console.error(e);
    }
  }
};


export default Layers
